import { BadgeCheck } from "lucide-react"

import { Badge } from "@/components/ui/badge"

interface VerifiedBadgeProps {
  show?: boolean
  size?: "sm" | "md"
}

export default function VerifiedBadge({
  show = true,
  size = "md",
}: VerifiedBadgeProps) {
  if (!show) return null

  const iconClass = size === "sm" ? "mr-0.5 h-3 w-3" : "mr-1 h-3.5 w-3.5"

  return (
    <Badge
      variant="outline"
      className="border-blue-400 bg-blue-500/20 text-blue-400"
    >
      <BadgeCheck className={iconClass} />
      Verificado
    </Badge>
  )
}
